export default __webpack_public_path__ + "static/media/img_major03_3.dc6ab7a4.jpg";